import Segment from './Segment';
import SegmentFactory from './SegmentFactory';
import DomainRegistry from '@/creditflowresearch/domain/DomainRegistry';

DomainRegistry.register(async (container, data) => {
  if (data?.marketSegments?.length) {
    Segment.initialize(data.marketSegments, SegmentFactory.createFromData);
  }
});

export { default } from './Segment';
export { default as Segment } from './Segment';
export { default as SegmentFactory } from './SegmentFactory';
export { default as CorpSegment } from './entities/CorpSegment';
export { default as FigSegment } from './entities/FigSegment';
export { default as SsaSegment } from './entities/SsaSegment';
export * from './constants';
